import { RootState } from "@/infrastructure/rootState";
import { omit } from "lodash";
import { some } from "lodash";

export const isDashboardLoading = ({ dashboard }: RootState) => some(dashboard.status, v => v !== "SUCCESS");

export const benchmarkExchanges = ({ dashboard }: RootState) => dashboard.meta.benchmarkExchanges;
export const defaultBenchmarkExchange = ({ dashboard }: RootState) => Object.keys(dashboard.benchmark)[0];
export const availableInvestmentStyle = (exchange: string) => ({ dashboard }: RootState) => {
  const selectedBenchmark = dashboard.benchmark[exchange];
  return selectedBenchmark ? [...new Set(selectedBenchmark.totalScore.map(e => e.investmentStyle))] : [];
};
export const benchmarkData = (exchange: string) => ({ dashboard }: RootState) => dashboard.benchmark[exchange];
export const availableGroup = (exchange: string) => ({ dashboard }: RootState) => {
  const selectedBenchmark = dashboard.benchmark[exchange];
  return selectedBenchmark ? [...new Set(selectedBenchmark.totalScore.map(e => e.group))] : [];
}

export const uniqueCountry = ({ dashboard }: RootState) => dashboard.performance.uniqueCountry;
export const performance = ({ dashboard }: RootState) => omit(dashboard.performance, ["uniqueCountry"]);
export const stockPerf = ({ dashboard }: RootState) => dashboard.performance.stock;
